import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent } from '@sim/form';
import { ClassName } from '@sim/role';

@Component({
  selector: 'app-tags-form',
  styleUrls: ['./tags-form.component.scss'],
  templateUrl: './tags-form.component.html',
})
export class TagsFormComponent extends BaseCtrlValueAccessorFormArrayComponent<string[]> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  get tags() {
    const form = this.form && this.form.controls;
    return form || [];
  }

  constructor(
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addTagHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage tag without a control');
    }

    const TagControl = new UntypedFormControl('');
    this.form.push(TagControl);
  }

  removeTagHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage tag without a control');
    }

    this.form.removeAt(index);
  }

}
